"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

require("./styles.less");

var styles = {
  "menu": "meepshop-meep-ui__submenu-largeMenu-styles__menu",
  "visible": "meepshop-meep-ui__submenu-largeMenu-styles__visible",
  "menuContent": "meepshop-meep-ui__submenu-largeMenu-styles__menuContent",
  "menuItem": "meepshop-meep-ui__submenu-largeMenu-styles__menuItem",
  "menuItemGroup": "meepshop-meep-ui__submenu-largeMenu-styles__menuItemGroup",
  "menuGroup": "meepshop-meep-ui__submenu-largeMenu-styles__menuGroup",
  "menuGroupContent": "meepshop-meep-ui__submenu-largeMenu-styles__menuGroupContent",
  "showThirdLevelMenuDivider": "meepshop-meep-ui__submenu-largeMenu-styles__showThirdLevelMenuDivider"
};

var MenuGroup = function MenuGroup(_ref) {
  var page = _ref.page,
      menuSettings = _ref.menuSettings,
      MenuComponent = _ref.MenuComponent,
      submenuSettings = _ref.submenuSettings;

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page, {
    menuSettings: menuSettings
  }),
      title = _useButtonSettings.title,
      url = _useButtonSettings.url,
      target = _useButtonSettings.target; // 第二層，最多到第三層


  var showThirdLevelMenuDivider = (submenuSettings === null || submenuSettings === void 0 ? void 0 : submenuSettings.showThirdLevelMenuDivider) || false;
  var renderTitle = url ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: url,
    target: target,
    passHref: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    target: target,
    className: "".concat(styles.menuItem, " ").concat(styles.menuItemGroup)
  }, title)) : /*#__PURE__*/_react["default"].createElement("h6", {
    className: "".concat(styles.menuItem, " ").concat(styles.menuItemGroup)
  }, title);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menuGroup
  }, renderTitle, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.menuGroupContent, " ").concat(showThirdLevelMenuDivider ? styles.showThirdLevelMenuDivider : '')
  }, page.pages.map(function (subPage) {
    return /*#__PURE__*/_react["default"].createElement(MenuComponent, {
      key: subPage.id,
      page: subPage,
      menuSettings: menuSettings,
      submenuSettings: submenuSettings
    });
  })));
};

var _default = MenuGroup;
exports["default"] = _default;